export default "__VITE_ASSET__BslLJyUG__"